import React from 'react';
import { candiesByNames, candyNames } from '../../../enums';
import { toCapitalize } from '../../../helpers';

export const candiesColorByNames = {
  [candyNames.Pink]: 1,
  [candyNames.Green]: 2,
  [candyNames.Blue]: 3,
  [candyNames.Yellow]: 4,
  [candyNames.Bonus]: 5,
};

const StatisticItem = ({ percentage, candy }) => {
  return (
    <div className='statistics-row'>
      <div className='statistics-row-item left'>
        <img className='pink-candy' src={candiesByNames[toCapitalize(candy)]} alt={candy} />
      </div>
      <div className='statistics-row-item center'>
        <div
          className={`statistics-row-item-line-holder type-${
            candiesColorByNames[toCapitalize(candy)]
          }`}
        >
          <div className='statistics-row-item-line-inner' style={{ width: `${percentage}%` }} />
        </div>
      </div>
      <div className='statistics-row-item right'>
        <p className='statistics-row-item-percent'>{percentage}%</p>
      </div>
    </div>
  );
};

export { StatisticItem };
